module.exports = __webpack_public_path__ + "img/late.39e4271b.png";